import axios from 'axios';
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import { ToolsForm } from './TaskRequirements';
import Highlighter from 'react-highlight-words';
import { decode as base64_decode } from 'base-64';
import { constant } from '../../../Utils/constants';
import TableSelect from '../../../Widgets/TableSelect';
import { API_DEVICE } from '../../../../../commons/api';
import React, { useEffect, useRef, useState } from 'react';
import { Form, Input, message, Modal, Select, Button } from 'antd';
import InputComponent from '../../../Widgets/InputComponent';
import localStorage from '../../../../../utils/localStorage';
import translation from '../../../../../commons/translation';

import { DownOutlined, SearchOutlined } from '@ant-design/icons';
import {
  getSitesList,
  getParameterList,
  getCmpointList,
  getwarningTypeList,
  getnotificationTypeList,
  submitConditionMonitor,
  getConditionMonitorById,
  getUsersList,
  getequipmentList,
  checkLimit
} from '../../../Utils/FormCalls';
import { StyledBox } from '../../../CSS/style';

const { Option } = Select;
// const fileData = new FormData();

const ConditionMonitoring = (props) => {
  const [sitesList, setSitesList] = useState([]);
  const [parameterList, setParameterList] = useState([]);
  const [cmpointList, setCmpointList] = useState([]);
  const [warningTypeList, setWarningTypeList] = useState([]);
  const [equipmentList, setEquipmentList] = useState([]);
  const [notificationTypeList, setNotificationTypeList] = useState([]);
  const [formObject, setFormObject] = useState(
    props.formObject && Object.keys(props.formObject).length > 0 ? props.formObject : {}
  );
  const [fileDataState, setFileDataState] = useState(new FormData());
  const [visible, setVisible] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [tableData, setTableData] = useState([]);
  const [EmailId, setEmailId] = useState('');
  // const [viewGauge, setViewGauge] = useState('true');
  // const [viewContinous, setViewContinous] = useState('false');
  // const [viewFault, setViewFault] = useState('false');
  const [MobileId, setMobileId] = useState('');
  const [SlackId, setSlackId] = useState('');
  const [WoId, setWoId] = useState('');
  const [SrId, setSrId] = useState('');
  const [usersList, setUsersList] = useState([]);
  const conditionMonitorRef = useRef();
  const [selectedPointTypeId, setSelectedPointTypeId] = useState('');
  const searchInput = useRef(null);

  // const getUserId = () => {
  //   return props.userProfile && props.userProfile.user && props.userProfile.user.Id
  //     ? props.userProfile.user.Id
  //     : '';
  // };
  const _getDataById = async (Id) => {
    let formObject = {};
    const path = props.location.pathname.split('/rubus/AMM/CMDetails/');
    const formId = Id ? Id : base64_decode(path[1]);
    if (formId !== 'new') {
      formObject = await getConditionMonitorById(formId, 'withId');
    }
    if (formId && formId !== 'new') {
      const parameterList = await getParameterList(
        formObject && formObject.Equipment ? formObject.Equipment : ''
      );
      setFormObject(formObject);
      setParameterList(parameterList);
    } else {
      setFormObject(formObject);
    }

    if (conditionMonitorRef.current) {
      conditionMonitorRef.current.setFieldsValue(formObject);
    }
  };

  useEffect(() => {
    _getDataById();

    (async () => {
      try {
        let notificationTypeListData = await getnotificationTypeList();
        let Sr = notificationTypeListData.filter((status) => status.Key === 'ServiceRequest');
        let Wo = notificationTypeListData.filter((status) => status.Key === 'WorkOrder');
        let Slack = notificationTypeListData.filter((status) => status.Key === 'Slack');
        let Email = notificationTypeListData.filter((status) => status.Key === 'Email');
        let Mobile = notificationTypeListData.filter((status) => status.Key === 'Mobile');

        setEmailId(Email[0]?.Value);
        setSlackId(Slack[0]?.Value);
        setWoId(Wo[0]?.Value);
        setSrId(Sr[0]?.Value);
        setMobileId(Mobile[0]?.Value);
        setNotificationTypeList(notificationTypeListData);
      } catch (error) {
        message.warning(`${error.message}`);
      }
      try {
        let warningTypeList = await getwarningTypeList();
        setWarningTypeList(warningTypeList);
      } catch (error) {
        message.warning(`${error.message}`);
      }
      try {
        let sitesList = await getSitesList();
        let formObj = conditionMonitorRef.current?.getFieldsValue() || {};
        formObj = {
          ...formObj,
          SiteId: localStorage.get('currentSite') ? parseInt(localStorage.get('currentSite')) : ''
        };
        conditionMonitorRef.current?.setFieldsValue(formObj);
        setSitesList(sitesList);
        setFormObject(formObj);
      } catch (error) {
        message.warning(`${error.message}`);
      }
      try {
        let cmpointList = await getCmpointList();
        setCmpointList(cmpointList);
      } catch (error) {
        message.warning(`${error.message}`);
      }
      try {
        let usersList = await getUsersList();
        setUsersList(usersList);
      } catch (error) {
        message.warning(`${error.message}`);
      }
    })();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const equipmentData = await getequipmentList();
        setEquipmentList(equipmentData);
      } catch (error) {
        console.error('Error fetching equipment list:', error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (
      props.formObject &&
      Object.keys(props.formObject).length === 0 &&
      Object.keys(formObject).length === 0
    ) {
      onReset();
    }
    if (props.formObject && Object.keys(props.formObject).length === 0) {
      conditionMonitorRef.current && conditionMonitorRef.current.setFieldsValue(props.formObject);
    }
    if (props.formObject && props.formObject !== formObject) {
      setFormObject(props.formObject);
    }
    setSelectedPointTypeId(conditionMonitorRef.current.getFieldValue('PointTypeId'));
  }, [formObject, conditionMonitorRef]);

  const handleChange = async (value, key) => {
    let formObject = conditionMonitorRef.current?.getFieldsValue();
    if (key === 'Equipment') {
      let parameterList = await getParameterList(value);
      setParameterList(parameterList);
      let selectedEquip = Object.values(equipmentList).filter((item) => item.AliasCode === value);
      formObject = {
        ...formObject,
        Equipment: value,
        EquipmentDescription: selectedEquip[0]?.Name || ''
      };
      conditionMonitorRef.current?.setFieldsValue(formObject);
      setVisible(false);
      setFormObject(formObject);
    }
    if (key === 'WarningTypeId') {
      formObject = {
        ...formObject,
        WarningTypeId: value
      };

      let list = Object.keys(warningTypeList)
        .map((obj) => warningTypeList[obj])
        .filter((item) => item.Value !== value);
      conditionMonitorRef.current?.setFieldsValue(formObject);
      setWarningTypeList(list);
      setFormObject(formObject);
    }
    if (key === 'PointTypeId') {
      formObject = conditionMonitorRef.current.getFieldsValue();
      let t1 = {
        ...formObject,
        NotificationTypeId: []
      };
      conditionMonitorRef &&
        conditionMonitorRef.current &&
        conditionMonitorRef.current.setFieldsValue(t1);
      setFormObject(t1);
      if (key === 'lastCreationTimeforWO') {
        formObject = {
          ...formObject,
          [key]: moment(value, 'HH:mm')
        };
      }
    }
  };

  const onFormsubmit = async (values) => {
    let userId =
      props.userProfile && props.userProfile.user && props.userProfile.user.Id
        ? props.userProfile.user.Id
        : '';
    let formObjectTemp = {
      ...values,
      ...(formObject && !formObject.Id ? { CreatedBy: userId } : {}),
      ...(formObject && formObject.Id ? { UpdatedBy: userId } : {})
    };

    delete formObjectTemp.EquipmentDescription;
    let statusResponse = await submitConditionMonitor(formObjectTemp, fileDataState);
    if (statusResponse && statusResponse.message) {
      _getDataById(statusResponse.Id);
      message.success(statusResponse.message);
      props.navigate('/rubus/AMM/CMList');
      setFileDataState(new FormData());
    } else if (statusResponse && statusResponse.Error) {
      message.error(statusResponse.Error);
    }
  };

  const onReset = () => {
    conditionMonitorRef.current.resetFields();
  };

  const getDeviceData = async () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');

    const headers = {
      method: 'GET',
      url: `${API_DEVICE.GetDevicesByParamCategory}?SiteId=${siteId}&ParameterCategory=Operational`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };

    try {
      const { data } = await axios(headers);
      setTableData(data);
      setFormObject(conditionMonitorRef.current.getFieldsValue());
      setVisible(true);
    } catch (error) {
      console.error('Error fetching device data:', error);
    }
  };

  const TableDropdownChange = async (value) => {
    let currentFormObject = conditionMonitorRef.current.getFieldsValue();
    currentFormObject = {
      ...currentFormObject,
      Equipment: value.AliasCode,
      DeviceCode: value.DeviceCode,
      DisplayCode: value.DisplayCode,
      EquipmentDescription: value.Name,
      AssetDescription: value.AssetDescription,
      Location: value.Location,
      LocationDescription: value.LocationDescription,
      ParameterCode: value.ParameterCode,
      AssetDisplayCode: value.AssetDisplayCode
    };
    const fetchedParameterList = await getParameterList(value.AliasCode);

    conditionMonitorRef.current.setFieldsValue(currentFormObject);
    setFormObject(currentFormObject);
    setParameterList(fetchedParameterList);
    setVisible(false);
  };

  const handleSelect = (value, key, subindex, keyName) => {
    let data = conditionMonitorRef.current.getFieldValue();

    if (data && data[keyName] && data[keyName][subindex] && data[keyName][subindex]) {
      data[keyName][subindex][key] = value;
    }
    if (data && data[key]) {
      data[key] = value;
    }

    //  if (keyName === 'Warnings') {
    //   data[keyName] = value; // Update the Warnings directly
    // } else if (data && data[key]) {
    //   data[key] = value; // Update the specific key
    // }
    conditionMonitorRef.current.setFieldsValue(data);
    setFormObject(data); // Update the formObject state
  };
  //   if (data && data[key]) {
  //     data[key] = value;
  //   }
  //   conditionMonitorRef.current.setFieldsValue(data);
  //   setFormObject(data);
  // };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation(props.translationCache, constant.search)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          style={{ width: 90, marginRight: 8 }}>
          {translation(props.translationCache, constant.search)}
        </Button>
        <Button
          danger
          onClick={() => handleReset(clearFilters, confirm)}
          style={{ width: 90 }}>
          {translation(props.translationCache, constant.Reset)}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const getDisableStatusContious = (notification) => {
    const selectedNotif =
      conditionMonitorRef.current && conditionMonitorRef.current.getFieldValue('NotificationTypeId')
        ? conditionMonitorRef.current.getFieldValue('NotificationTypeId')
        : [];

    if (selectedNotif && Array.isArray(selectedNotif)) {
      if (
        notification &&
        notification.Key &&
        notification.Key === 'ServiceRequest' &&
        selectedNotif.includes(WoId)
      ) {
        return true;
      } else if (
        notification &&
        notification.Key &&
        notification.Key === 'WorkOrder' &&
        selectedNotif.includes(SrId)
      ) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  };

  const onParameterChange = (key, value) => {
    const currentParameterList = parameterList;
    const currentFormObject = conditionMonitorRef.current.getFieldsValue();

    let selectedParameter =
      currentParameterList &&
      Array.isArray(currentParameterList) &&
      currentParameterList.filter((parameter) => parameter.ParameterAlias === value);

    const updatedFormObject1 = {
      ...currentFormObject,
      [key]: value,
      UOM:
        selectedParameter && selectedParameter[0] && selectedParameter[0].UOM
          ? selectedParameter[0].UOM
          : ''
    };

    conditionMonitorRef.current && conditionMonitorRef.current.setFieldsValue(updatedFormObject1);
    setFormObject(updatedFormObject1);
  };

  const GuageId1 =
    cmpointList && Array.isArray(cmpointList) ? cmpointList.filter((e) => e.Key === 'Guage') : [];

  const ContinousId = Array.isArray(cmpointList)
    ? cmpointList.filter((e) => e.Key === 'Continuous')
    : [];
 const themeBackground = props && props.themeValue && props.themeValue.token && props.themeValue.token.colorBgBase;
 
  // const FaultId = Array.isArray(cmpointList) ? cmpointList.filter((e) => e.Key === 'Fault') : [];
  return (
    <>
      <Form
        ref={conditionMonitorRef}
        onFinish={onFormsubmit}
        onKeyDown={(e) => {
          e.key === 'Enter' && e.preventDefault();
        }}
        initialValues={formObject}
        layout="horizontal"
        labelCol={{ flex: '130px' }}
        labelAlign="right"
        labelWrap
        validateMessages={{
          required: '${label} is required!',
          types: {
            email: '${label} is not a valid email!',
            number: '${label} is not a valid number!'
          },
          number: {
            range: '${label} must be between ${min} and ${max}'
          },
          pattern: {
            mismatch: '${label} does not match pattern'
          }
        }}>
        <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
          <Button type="primary" htmlType="submit">
            {translation(props.translationCache, constant.submit)}
          </Button>
        </div>
        <StyledBox  themeBackground={themeBackground} style={{padding:"20px"}}>
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            <Form.Item name="Id"></Form.Item>
            <Form.Item
              label={translation(props.translationCache, constant.cMPoint)}
              name="Name"
              rules={[{ required: true }]}
              style={{ width: '100%', flex: '50%' }}>
              <InputComponent
                placeholder={translation(props.translationCache, 'Input CMPoint')}
                style={{ width: '70%' }}
                value={formObject && formObject.Name ? formObject.Name : ''}
                disabled={formObject && formObject.Id ? true : false}
              />
            </Form.Item>
            <Form.Item
              label={translation(props.translationCache, constant.cMPointDescription)}
              name="Description"
              style={{ width: '100%', flex: '50%' }}
              rules={[{ required: true }]}>
              <InputComponent
                placeholder={translation(props.translationCache, 'Input CMPoint Description')}
                style={{ width: '70%' }}
                value={'WO-11'}
              />
            </Form.Item>
            <Form.Item name="Equipment"></Form.Item>

            <Form.Item
              style={{ width: '100%', flex: '50%' }}
              label={translation(props.translationCache, constant.equipment)}
              name="DisplayCode"
              rules={[{ required: true }]}>
              <InputComponent
                disabled={true}
                suffix={
                  <DownOutlined
                    style={{
                      color: formObject && formObject.Id ? null : '#1a3b5c',
                      cursor: formObject && formObject.Id ? 'not-allowed' : null,
                      opacity: formObject && formObject.Id ? '0.8' : null
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      if (formObject && !formObject.Id) {
                        getDeviceData();
                        setVisible(true);
                      }
                    }}
                  />
                }
                style={{ width: '70%' }}
                placeholder={translation(props.translationCache, constant.SelectEquipment)}
              />
            </Form.Item>
            <Modal
              open={visible}
              width={800}
              closable
              title={translation(props.translationCache, constant.selectEquipment)}
              onOk={() => setVisible(true)}
              onCancel={() => setVisible(false)}>
              <TableSelect
                data={tableData}
                translationCache={props.translationCache}
                key="Equipment"
                columns={[
                  {
                    title: translation(props.translationCache, 'Equipment'),
                    dataIndex: 'DisplayCode',
                    key: 'DisplayCode',
                    ...getColumnSearchProps('DisplayCode')
                  },
                  {
                    title: translation(props.translationCache, 'Equipment Description'),
                    dataIndex: 'Name',
                    key: 'Name',
                    ...getColumnSearchProps('Name')
                  }
                ]}
                handleDropdownChange={(e) => TableDropdownChange(e, 'visible')}
              />
            </Modal>
            <Form.Item
              label={translation(props.translationCache, constant.equipmentDescription)}
              name="EquipmentDescription"
              style={{ width: '100%', flex: '50%' }}
              rules={[
                {
                  required: true,
                  message: translation(props.translationCache, 'Autopopulated based on Equipment')
                }
              ]}>
              <InputComponent
                placeholder={translation(props.translationCache, 'Autopopulated based on Equipment')}
                disabled={true}
                style={{ width: '70%' }}
              />
            </Form.Item>

            <Form.Item
              label={translation(props.translationCache, constant.location)}
              name="AssetDisplayCode"
              style={{ width: '100%', flex: '50%' }}
              rules={[
                {
                  required: true,
                  message: translation(props.translationCache, 'Autopopulated based on Equipment')
                }
              ]}>
              <InputComponent
                placeholder={translation(props.translationCache, 'Autopopulated based on Equipment')}
                disabled={true}
                style={{ width: '70%' }}
              />
            </Form.Item>
            <Form.Item
              label={translation(props.translationCache, constant.locationDescription)}
              name="LocationDescription"
              style={{ width: '100%', flex: '50%' }}
              rules={[
                {
                  required: true,
                  message: translation(props.translationCache, 'Autopopulated based on Equipment')
                }
              ]}>
              <InputComponent
                placeholder={translation(props.translationCache, 'Autopopulated based on Equipment')}
                disabled={true}
                style={{ width: '70%' }}
              />
            </Form.Item>

            <Form.Item
              label={translation(props.translationCache, constant.site)}
              name="SiteId"
              style={{ width: '100%', flex: '50%' }}
              rules={[
                { required: true, message: translation(props.translationCache, 'Please Input Site!') }
              ]}>
              <Select
                style={{ width: '70%' }}
                disabled={formObject && formObject.Id ? true : false}
                placeholder={translation(props.translationCache, 'Select Site')}>
                {sitesList &&
                  Array.isArray(sitesList) &&
                  sitesList.map((site, index) => {
                    return (
                      <Option key={index} value={site.Id}>
                        {' '}
                        {site.Name}{' '}
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>

            <Form.Item
              label={translation(props.translationCache, constant.parameter)}
              name="ParameterAlias"
              style={{ width: '100%', flex: '50%' }}
              rules={[
                {
                  required: true,
                  message: translation(props.translationCache, 'Please Input Parameter!')
                }
              ]}>
              <Select
                style={{ width: '70%' }}
                placeholder={translation(props.translationCache, 'Select Parameter')}
                onChange={(e) => onParameterChange('parameterAlias', e)}>
                {parameterList &&
                  Array.isArray(parameterList) &&
                  parameterList.map((parameter, index) => (
                    <Option key={index} value={parameter.ParameterAlias}>
                      {parameter.EdgeCode} @ {parameter.ParameterDescription}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
            <Form.Item
              label={translation(props.translationCache, constant.cMPointType)}
              name="PointTypeId"
              style={{ width: '100%', flex: '50%' }}
              rules={[
                {
                  required: true,
                  message: translation(props.translationCache, 'Please Input CMPoint Type!')
                }
              ]}>
              <Select
                disabled={formObject && formObject.Id ? true : false}
                style={{ width: '70%' }}
                placeholder={translation(props.translationCache, 'Select CM Point Type')}
                onChange={(e) => handleChange(e, 'PointTypeId')}>
                {cmpointList &&
                  Array.isArray(cmpointList) &&
                  cmpointList.map((parameter, index) => (
                    <Option key={index} value={parameter.Value}>
                      {translation(props.translationCache, parameter.Key)}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="UOM"
              name="UOM"
              style={{ width: '100%', flex: '50%' }}
              rules={
                [
                  // { required: true, message: translation(translationCache, '') },
                ]
              }>
              <InputComponent
                placeholder={'Auto Populated from Parameters'}
                disabled={true}
                style={{ width: '70%' }}
              />
            </Form.Item>
            <Form.Item
              label={translation(props.translationCache, constant.minimumValue)}
              name="MinimumValue"
              style={{ width: '100%', flex: '50%' }}
              rules={[
                {
                  required: false,
                  message: translation(props.translationCache, 'Please Input Minimum Value')
                },
                {
                  validator: (_, value) =>
                    checkLimit(
                      value,
                      'MinimumValue',
                      conditionMonitorRef.current.getFieldsValue() || {},
                      { validateField: 'MaximumValue', operator: 'less' }
                    )
                }
              ]}>
              <InputComponent
                placeholder={translation(props.translationCache, 'Please Input Minimum Value')}
                style={{ width: '70%' }}
              />
            </Form.Item>
            <Form.Item
              label={translation(props.translationCache, constant.maximumValue)}
              name="MaximumValue"
              style={{ width: '100%', flex: '50%' }}
              rules={[
                {
                  required: false,
                  message: translation(props.translationCache, 'Please Input Maximum Value')
                },
                {
                  validator: (_, value) =>
                    checkLimit(
                      value,
                      'MaximumValue',
                      conditionMonitorRef.current.getFieldsValue() || {},
                      { validateField: 'MinimumValue', operator: 'greater' }
                    )
                }
              ]}>
              <InputComponent
                placeholder={translation(props.translationCache, 'Please Input Maximum Value')}
                style={{ width: '70%' }}
              />
            </Form.Item>
          </div>
        </StyledBox>

        <StyledBox  themeBackground={themeBackground} style={{padding:"20px"}}>
        {selectedPointTypeId === GuageId1[0]?.Value ? (
          <Form.List name="Warnings">
            {(fields, operation) => (
              <ToolsForm
                fields={fields}
                translationCa={props.translationCache}
                add={operation.add}
                remove={operation.remove}
                SrId={SrId}
                WoId={WoId}
                EmailId={EmailId}
                MobileId={MobileId}
                SlackId={SlackId}
                formObject={
                  // formObject
                  conditionMonitorRef.current !== null
                    ? conditionMonitorRef.current.getFieldsValue(true)
                    : {}
                }
                onNotificationChange={handleSelect}
                warningTypeList={warningTypeList}
                notificationTypeList={notificationTypeList}
                usersList={usersList}
                conditionMonitorRef={conditionMonitorRef}
              />
            )}
          </Form.List>
        ) : null}
        {selectedPointTypeId === ContinousId[0]?.Key ? (
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            <Form.Item
              label={translation(props.translationCache, constant.frequencySetPoint)}
              name={'FrequencySetPoint'}
              rules={[{ required: true }]}
              style={{ width: '100%', flex: '50%', marginTop: '30px' }}>
              <InputComponent
                placeholder={translation(props.translationCache, 'Input FrequencySetPoint')}
                style={{ width: '70%' }}
              />
            </Form.Item>
            <Form.Item
              label={translation(props.translationCache, constant.rollOverSetPoint)}
              name={'RollOverSetPoint'}
              rules={[{ required: true }]}
              style={{ width: '100%', flex: '50%', marginTop: '30px' }}>
              <InputComponent
                placeholder={translation(props.translationCache, 'Input Roll OverSetPoint')}
                style={{ width: '70%' }}
              />
            </Form.Item>
            <Form.Item
              label={translation(props.translationCache, constant.notificationType)}
              name={'NotificationTypeId'}
              rules={[
                {
                  required: false,
                  message: translation(props.translationCache, 'Please Input Notification Type!')
                }
              ]}
              style={{ width: '100%', flex: '50%' }}>
              <Select
                showArrow={true}
                mode="multiple"
                style={{ width: '70%' }}
                placeholder={translation(props.translationCache, 'Select Notification Type')}
                onChange={(e) => handleSelect(e, 'NotificationTypeId')}>
                {notificationTypeList &&
                  Array.isArray(notificationTypeList) &&
                  notificationTypeList.map(
                    (notification, index) => (
                      (
                        <Option
                          key={index}
                          value={notification.Value}
                          disabled={getDisableStatusContious(notification)}>
                          {notification.Key}
                        </Option>
                      )
                    )
                  )}
              </Select>
            </Form.Item>
            {(conditionMonitorRef.current &&
              conditionMonitorRef.current.getFieldValue('NotificationTypeId') &&
              conditionMonitorRef.current.getFieldValue('NotificationTypeId').includes(EmailId)) ||
              (conditionMonitorRef.current &&
                conditionMonitorRef.current.getFieldValue('NotificationTypeId') &&
                conditionMonitorRef.current
                  .getFieldValue('NotificationTypeId')
                  .includes(MobileId)) ? (
              <Form.Item
                style={{ flex: '50%', width: '100%' }}
                labelCol={{ flex: '130px' }}
                label={translation(props.translationCache, constant.user)}
                name={'Emails'}
                rules={[
                  {
                    required: true,
                    message: translation(props.translationCache, 'Please Select User!')
                  }
                ]}>
                <Select
                  showArrow={true}
                  mode="multiple"
                  placeholder={translation(props.translationCache, 'Select User')}
                  style={{ width: '70%' }}>
                  {usersList.map((item, index) => (
                    <Option key={index} value={item.Email}>
                      {' '}
                      {item.FirstName}{' '}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            ) : null}

            {conditionMonitorRef.current &&
              conditionMonitorRef.current.getFieldValue('NotificationTypeId') &&
              conditionMonitorRef.current.getFieldValue('NotificationTypeId').includes(SlackId) ? (
              <Form.Item
                style={{ flex: '50%', width: '100%' }}
                labelCol={{ flex: '130px' }}
                label={translation(props.translationCache, constant.channel)}
                name={'ChannelName'}
                rules={[
                  {
                    required: true,
                    message: translation(props.translationCache, 'Please Input Channel')
                  }
                ]}>
                <InputComponent
                  placeholder={translation(props.translationCache, 'Input Channel')}
                  style={{ width: '70%' }}
                />
              </Form.Item>
            ) : null}
            <Form.Item style={{ flex: '50%' }}>
              <InputComponent style={{ width: '70%', display: 'none' }} />
            </Form.Item>
          </div>
        ) : null}
        </StyledBox>
      </Form>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    themeValue: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache,
    userProfile: state.LayoutReducer.loggedInProfile
  };
};

export default connect(mapStateToProps)(ConditionMonitoring);
